import React, { Component } from "react";
import styles from "../../../assets/css/modules/containers/shadowed-container.css";

export default class ShadowedContainer extends Component {
  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div
              className={
                this.props.className +
                " " +
                styles.shadowedContainer +
                " children"
              }
            >
              {this.props.children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
